import ViewRfq from '../../../../../../client/src/rfq/src/viewmodel/ViewRfqViewModel';
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesViewRfq extends DesBaseRfq {

    constructor() {
        console.log('DesViewRfq invoked');
        super(ViewRfq);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfq.observedAttributes];
    }
}

if (!window.customElements.get('des-view-rfq')) {
    window.customElements.define('des-view-rfq', DesViewRfq);
}
